$(document).ready(function(){
    $('.footer-title').on('click',function(e){
        e.preventDefault();
        if($(this).children('i').hasClass('fa-chevron-right')){
            $('.footer-title i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
            $('.footer-title').parent('div').removeClass('opened');
        }else{
            $('.footer-title i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
            $(this).children('i').toggleClass('fa-chevron-down').toggleClass('fa-chevron-right');
            $('.footer-title').parent('div').removeClass('opened');
            $(this).children('i').parent('.footer-title').parent('div').addClass('opened');
        }
    });

    $('#main-nav:not(.is_mobile) > ul > li > a > i').on('click',function(e){
        if($(window).width() < 992){
            e.preventDefault();
            if($(this).hasClass('fa-chevron-right')){
                $('#main-nav i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                $('#main-nav .sub-menu').hide();
            }else{
                $('#main-nav i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                $(this).toggleClass('fa-chevron-down').toggleClass('fa-chevron-right');
                $('#main-nav .sub-menu').hide();
                $(this).parent('a').next('.sub-menu').show();
                $(this).parent('div').next('.sub-menu').show();
            }
    
        }
    });

    $('#main-nav.is_mobile .menu-main > .menu-item-has-children > a').on('click',function(e){
            e.preventDefault();
            var liParent = $(this).closest('li');
            if($(this).children('i').hasClass('fa-chevron-right')){
                $(this).children('i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                $('.sub-menu:first-child', liParent).hide();
            } else {
                $(this).children('i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                $(this).hide().next('.sub-menu').show();
            }
    });

    // Specific menu group
    $('#main-nav.is_mobile .menu-main > .menu-item-has-children > div > a').on('click',function(e){
            e.preventDefault();
            if($(this).next('i').hasClass('fa-chevron-right')){
                $('#main-nav i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                $('#main-nav .sub-menu').hide();
            }else{
                $('#main-nav i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
                $(this).next('i').toggleClass('fa-chevron-down').toggleClass('fa-chevron-right');
                $('#main-nav .sub-menu').hide();
                $('#main-nav.is_mobile .menu-main > .menu-item-has-children > a').show();
                //$(this).parent('a').next('.sub-menu').show();
                //$(this).next('.sub-menu').show();
                $(this).parent('div').next('.sub-menu').show();
            }
    });
    $('#main-nav.is_mobile .menu-main i.fa-times').on('click',function(e){
        e.preventDefault();
        $(this).parents('.sub-menu').hide().prev('a').show().children('i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
    });

    $('.header-mobile-menu').on('click',function(e){
        e.preventDefault();
        $(this).toggleClass('fa-bars').toggleClass('fa-times');
        if($(this).hasClass('fa-bars')){
            $('.nav-container').hide();
        }else{
            $('.nav-container').show();
        }
    });

    $(window).on('click', function (e){
        if(!$(e.target).hasClass('header-mobile-menu')){
            if($(e.target).parents('.nav-container').length == 0 && $('.header-mobile-menu').hasClass('fa-times')){
                $('.header-mobile-menu').toggleClass('fa-bars').toggleClass('fa-times');
                $('.nav-container').hide();
            }
        }
    });

    $('.header-mobile-search').on('click',function(){
        if($(window).width() < 992){
            $('#search-form').css('display','flex');
        }
    });
    $('.header-mobile-search-close').on('click',function(){
        if($(window).width() < 992){
            $('#search-form').hide();
        }
    });

    $('.btn-back').on('click',function(e){
        e.preventDefault();
        if(document.referrer && document.referrer.indexOf(window.location.origin) != -1){
            history.back();
        }else{
            window.location = window.location.origin;
        }
    });

    $('.implantations .implantations-lieu-title').on('click',function(){
        $(this).parents('.implantations-lieu').toggleClass('opened');
    });

    $('.implantations .implantations-fr-show-more').on('click',function(e){
        e.preventDefault();
        $('.implantations-france-more').show();
        $(this).hide();
    });

    $('.implantations .implantations-int-show-more').on('click',function(e){
        e.preventDefault();
        $('.implantations-international-more').show();
        $(this).hide();
    });

    $('.page-excerpt a').on('click',function(e){
        e.preventDefault();
        $('.page-excerpt .preview-full').show();
        $('.page-excerpt .preview-limited, .page-excerpt a').hide();
    });

    $('.mobile-show-filters').on('click',function(e){
        e.preventDefault();
        $('.filters').show();
        $(this).hide();
        $('.mobile-hide-filters').show();
    });

    $('.mobile-hide-filters').on('click',function(e){
        e.preventDefault();
        $('.filters').hide();
        $(this).hide();
        $('.mobile-show-filters').show();
    });

    $('body').on('click','.view-switcher span',function(){
        $('.view-switcher span.active').removeClass('active');
        $(this).addClass('active');
        if($(this).data('vue') == 'list'){
            $('#expert-map').hide();
            $('.list-femmeshommes-row').show();
        }else{
            $('#expert-map').show();
            $('.list-femmeshommes-row').hide();
        }
    });

    $('.backtotop').on('click',function(){
        $('html,body').animate({
            scrollTop: 0
        }, 700);
    });

});